var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-select',_vm._b({ref:"field",attrs:{"id":_vm.identifier,"options":_vm.filtered_options,"expand-on-focus":_vm.expandOnFocus || _vm.showAll},on:{"focus":function($event){return _vm.$emit('focus')},"search":_vm.search,"input":_vm.pick},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_vm._t("option",null,{"option":option})]}},{key:"right_addon",fn:function(ref){
var option = ref.option;
return [_vm._t("right_addon",null,{"option":option})]}}],null,true)},'base-select',_vm.select_props,false))}
var staticRenderFns = []

export { render, staticRenderFns }